import type { ReactNode } from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';

interface StatsCardProps {
  title: string;
  value: string | number;
  icon: ReactNode;
  trend?: {
    value: number;
    isPositive: boolean;
  };
  description?: string;
}

export function StatsCard({ title, value, icon, trend, description }: StatsCardProps) {
  return (
    <div className="bg-surface rounded-xl border border-theme p-6">
      <div className="flex items-start justify-between">
        <div>
          <p className="text-sm font-medium text-theme-secondary">{title}</p>
          <p className="mt-2 text-3xl font-bold text-theme">{value}</p>
          {trend && (
            <div className="mt-2 flex items-center gap-1">
              {trend.isPositive ? (
                <TrendingUp className="w-4 h-4 text-green-500" />
              ) : (
                <TrendingDown className="w-4 h-4 text-red-500" />
              )}
              <span
                className={`text-sm font-medium ${
                  trend.isPositive ? 'text-green-600' : 'text-red-600'
                }`}
              >
                {trend.isPositive ? '+' : ''}{trend.value}%
              </span>
              {description && (
                <span className="text-sm text-theme-tertiary">{description}</span>
              )}
            </div>
          )}
        </div>
        <div className="p-3 rounded-xl bg-indigo-50 dark:bg-indigo-900/20">
          {icon}
        </div>
      </div>
    </div>
  );
}
